import { useContext, useEffect, useMemo, useState } from 'react';

import Context from '../../../store/context';
import useGet from './useGet';

//params always should have three elements

const useGetPaginated = (apiMethod, params, shouldFetch = true) => {
  // State
  const [page, setPage] = useState(0);
  const [tokens, setTokens] = useState([]);
  const [token, setToken] = useState(null);
  const [list, setList] = useState([]);

  const getParams = useMemo(() => [{ ...params, ...(token && { token }) }], [params, token]);

  // Http get
  const { isSuccess, isError, data, refetch, errorMessage, isLoading } = useGet(apiMethod, getParams, shouldFetch);

  const {
    modal: { showError }
  } = useContext(Context);

  useEffect(() => {
    if (isSuccess) {
      // Validar que data sea un objeto antes de desestructurarlo
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        console.error('useGetPaginated: data debe ser un objeto con items y token', data);
        showError({ 
          title: 'Error en la vista', 
          description: 'Formato de datos inválido recibido del servidor' 
        });
        return;
      }

      const { items: list, token: incomingToken } = data;
      setList(list || []);
      const shouldAddToken = !!incomingToken && !tokens.includes(incomingToken);
      if (shouldAddToken) {
        setTokens(prevTokens => prevTokens.concat(incomingToken));
      }
    } else if (isError) {
      showError({ title: 'Error en la vista', description: errorMessage });
    }
  }, [data, isError, isSuccess, showError, tokens, errorMessage]);

  useEffect(() => {
    const pageIndex = page - 1;
    if (pageIndex === -1) {
      setToken(null);
    } else {
      if (pageIndex < tokens.length) {
        setToken(tokens[pageIndex]);
      }
    }
  }, [page, tokens]);

  useEffect(() => {
    setPage(0);
    setTokens([]);
    setToken(null); // Resetear el token inmediatamente cuando cambian los parámetros
    setList([]); // Limpiar la lista cuando cambian los parámetros para evitar mostrar datos inconsistentes
  }, [params]);

  const editCurrentPage = increment => {
    setPage(prevPage => prevPage + 1 * increment);
  };

  const setCurrentPage = newPage => {
    setPage(newPage);
  };

  const tokensLength = tokens.length;
  const totalPages = tokensLength === 0 ? 1 : page === tokensLength ? tokensLength + 1 : tokensLength;
  const existsNextPage = page < tokensLength;
  const showPagination = list.length > 0 || tokensLength > 0;

  return {
    list,
    refetch,
    pagination: { showPagination, editCurrentPage, setCurrentPage, totalPages, currentPage: page, existsNextPage },
    isLoading,
    isError,
    errorMessage
  };
};

export default useGetPaginated;
